// extracted by mini-css-extract-plugin
export var actionButton = "_pg-0";
export var actionMenuContainer = "_pg-i";
export var bubble = "_pg-2";
export var bubbleActionMenu = "_pg-j";
export var bubbleContext = "_pg-6";
export var bubbleItems = "_pg-7";
export var customer = "_pg-3";
export var divider = "_pg-8";
export var fileList = "_pg-9";
export var hiddenComment = "_pg-o";
export var infoAbove = "_pg-a";
export var internal = "_pg-4";
export var lightActionButton = "_pg-1";
export var link = "_pg-b";
export var merchant = "_pg-5";
export var message = "_pg-c";
export var profilePicture = "_pg-e";
export var quillToolbarContainer = "_pg-f";
export var senderDate = "_pg-g";
export var senderDateCustomer = "_pg-h";
export var senderName = "_pg-d";
export var time = "_pg-k";
export var uploadedImage = "_pg-l";
export var username = "_pg-m";
export var xsmall = "_pg-n";